import { LitElement, html, nothing } from 'lit';
import { t } from '../i18n';
import { sanitizeImageUrl } from '../url-sanitizer';
import type { PendingGoalsState } from './shared';
import { defineZenComponent } from './register';

export class ZenPendingGoals extends LitElement {
  static properties = {
    state: { attribute: false },
  };

  declare state: PendingGoalsState;

  constructor() {
    super();
    this.state = {
      uploadEntries: [],
      goals: [],
    };
  }

  createRenderRoot() {
    return this;
  }

  private renderPlaceholderCard(dataUrl: string | null) {
    const safeDataUrl = sanitizeImageUrl(dataUrl);
    return html`
      <div class="goal-card" style="opacity:0.75;">
        ${safeDataUrl
          ? html`<img class="goal-thumb" alt="" src=${safeDataUrl}>`
          : nothing}
        <div class="goal-header">
          <div style="display:flex;align-items:center;gap:8px;flex:1;">
            <span class="mi mi-xs spin" style="color:var(--accent);">progress_activity</span>
            <span style="color:var(--text-muted);font-size:14px;">${String(t('analyzingQueue1'))}</span>
          </div>
        </div>
      </div>
    `;
  }

  render() {
    const { uploadEntries, goals } = this.state;
    if (uploadEntries.length === 0 && goals.length === 0) return nothing;

    return html`
      <div class="pending-goals-header">
        <span class="mi mi-xs">add_circle</span>
        <span>${String(t('analyzing'))}</span>
      </div>
      <div>
        ${uploadEntries.map((entry) => this.renderPlaceholderCard(entry.dataUrl))}
        ${goals.length > 0 ? html`<zen-goal-list .sections=${[{ icon: '', label: '', count: 0, goals }]}></zen-goal-list>` : nothing}
      </div>
    `;
  }
}

defineZenComponent('zen-pending-goals', ZenPendingGoals);
